// extracted by mini-css-extract-plugin
export default {"semiTitle":"item_semiTitle__64eT3","lineButtons":"item_lineButtons__Yhq7P","headers":"item_headers__w8Xbj","twoInLine":"item_twoInLine__v6NSm","blokInputs":"item_blokInputs__A7yag"};